export default __webpack_public_path__ + "static/media/highlight-9-new.5a922f12.jpg";